const HEAD_RENDER_TIMEOUT = 500

export const usePageViewed = (pageType: EGTMPageType) => {
	if (process.server) return

	const nuxtApp = useNuxtApp()
	const head = injectHead()
	const gtmService = useGTMService()
	if (!gtmService) return

	const waitForHeadRendered = () => {
		if (nuxtApp.isHydrating) return Promise.resolve()

		return new Promise<void>((resolve) => {
			const settle = () => {
				clearTimeout(timeout)
				unhook()
				resolve()
			}

			const unhook = head.hooks.hook('dom:rendered', settle)
			const timeout = setTimeout(settle, HEAD_RENDER_TIMEOUT)
		})
	}

	onMounted(async () => {
		await waitForHeadRendered()
		nuxtApp.runWithContext(() => gtmService.pageViewed({ page_type: pageType }))
	})
}
